import { Injectable } from '@angular/core';

import { Storage } from '@ionic/storage-angular';

@Injectable({
  providedIn: 'root'
})
export class StorageService {
  private _storage: Storage | null = null;
  private _ready: Promise<void>;

  constructor(private storage: Storage) {
    this._ready = this.init();
  }

  private async init() {
    if (!this._storage) {
      const storage = await this.storage.create();
      this._storage = storage;
    }
  }

  public async awaitReady(): Promise<void> {
    return this._ready;
  }

  public async set(key: string, value: any) {
    await this.awaitReady();
    this._storage?.set(key, value);
  }

  public async get(key: string) {
    await this.awaitReady();
    return this._storage?.get(key);
  }

  public async remove(key: string) {
    await this.awaitReady();
    return this._storage?.remove(key);
  }
}
